import { useState, useEffect } from 'react';
import { useApi } from '../api/hooks';

interface VersionInfo {
  version: string;
  buildVersion: string;
  apiBaseUrl: string;
}

export function useVersion() {
  const [versionInfo, setVersionInfo] = useState<VersionInfo | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);
  const { request, apiBaseUrl } = useApi();

  useEffect(() => {
    const fetchVersion = async () => {
      try {
        setLoading(true);
        setError(null);
        const data = await request('/mgmt/version', 'GET');
        setVersionInfo({
          version: (data as any)?.version || 'unknown',
          buildVersion: __APP_VERSION__,
          apiBaseUrl: apiBaseUrl
        });
      } catch (err) {
        setError(err instanceof Error ? err : new Error('Failed to fetch version'));
        // Fallback to apiBaseUrl only if version fetch fails
        setVersionInfo({
          version: 'unknown',
          buildVersion: __APP_VERSION__,
          apiBaseUrl: apiBaseUrl
        });
      } finally {
        setLoading(false);
      }
    };

    fetchVersion();
    const interval = setInterval(fetchVersion, 15 * 60 * 1000);
    return () => clearInterval(interval);
  }, [request, apiBaseUrl]);

  const hasVersionMismatch = !!(
    versionInfo &&
    versionInfo.buildVersion !== versionInfo.version &&
    versionInfo.buildVersion !== 'unknown' &&
    versionInfo.version !== 'unknown'
  );

  return { versionInfo, loading, error, hasVersionMismatch };
}